import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppFab from "./WhatsAppFab";
import LaunchBanner from "./LaunchBanner";

const PageShell = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-[#FAF9F6]">
    <LaunchBanner />
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
    <WhatsAppFab />
  </div>
);

export default PageShell;
